//import store from '@/store'

export const logoutMixin = {

    methods: {
        efetuarLogout () {
            this.$store.commit('DESLOGAR_USUARIO');

            this.$router.push({ name: "login" });
            // localStorage.clear();

            this.$store.state.token = null
            this.$store.state.usuario = null
            this.$store.state.perfil = null
            this.$store.state.nome = null

        },

        efetuarLogin () {
            this.$store.dispatch('efetuarLogin', this.usuario)
              .then(() => {
                this.$router.push( { name: 'dashboard' })
                this.mensagemErro = ''
              } )
              .catch( erro => {
                console.table(erro)
                if(erro.request.status === 401){
                    this.mensagemErro = 'Login ou senha incorretos!'
                }else{
                   this.mensagemErro = 'Sistema indisponível. Tente novamente mais tarde!'
                }
              });
          }

    }

}
